
    const toggle = document.getElementById("btnThemeToggle");
    const icon = document.getElementById("themeIcon");
    const label = document.getElementById("themeLabel");
    function updateThemeUI(theme) {
      if (icon) icon.textContent = theme === 'dark' ? '☀️' : '🌙';
      if (label) label.textContent = theme === 'dark' ? 'Light' : 'Dark';
    }
    if (toggle) {
      updateThemeUI(document.documentElement.getAttribute('data-theme') || 'light');
      toggle.addEventListener('click', () => {
        const cur = document.documentElement.getAttribute('data-theme') || 'light';
        const next = cur === 'dark' ? 'light' : 'dark';
        document.documentElement.setAttribute('data-theme', next);
        localStorage.setItem('rashuv_theme', next);
        updateThemeUI(next);
      });
    }
  